module.exports = __webpack_public_path__ + "img/material_title.bb82884b.png";